<div class="container">
    <br>
    <div class="row">
        <div class="col-sm-12 col-md-4 col-lg-4">
            <h3 class="p-blanco mb-3">Red de congregaciones</h3>
            <p class="p-nota2">Uniendo fe y acción para la salud de México, conformada en 2004</p>
        </div>
        <div class="col-sm-12 col-md-4 col-lg-4">
            <h3 class="p-blanco mb-3">Contacto</h3>
            <p class="p-nota2">contacto@redsaludmexico.org</p>
            <p class="p-nota2">Ciudad de México, México</p>
        </div>
        <div class="col-sm-12 col-md-4 col-lg-4">
            <h3 class="p-blanco mb-3">Legal</h3>
            <p class="p-nota2">Aviso de privacidad</p>
            <p class="p-nota2">Transparencia financiera</p>
        </div>
    </div>
    <div class="my-1">
        <p class="p-nota2 text-center">© 2026 Red de Congregaciones de Hermanas Católicas en México. Todos los derechos reservados.</p>
    </div>
    <br>
</div>